module.exports = __webpack_public_path__ + "media/images/escu_ctes_hor-61356e1fee7cfaaaf1870db25441a145.svg";